import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './components/Auth/Login.vue'
import Dashboard from './views/Dashboard.vue'
import Cleaning from "./views/Cleaning.vue";
import Cleanings from "./views/Cleanings.vue";
import Containers from "./views/Containers.vue";
import Companies from "./views/Companies.vue";
import Cargos from "./views/Cargos.vue";
import Vehicles from "./views/Vehicles.vue";
import NotFound from "./components/NotFound";
import store from "./store";
import Users from "./views/Users";
import EditUser from "./views/EditUser";

Vue.use(VueRouter)

const routes = [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresVisitor: true
      }
    },
    {
      path: '/containers',
      name: 'containers',
      component: Containers,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cargos',
      name: 'cargos',
      component: Cargos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/companies',
      name: 'companies',
      component: Companies,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cleanings',
      name: 'cleanings',
      component: Cleanings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cleanings/:id',
      name: 'cleaning',
      component: Cleaning,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/vehicles',
      name: 'vehicles',
      component: Vehicles,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true,
        requiresPermission: 'manage users'
      },
    },
    {
      path: '/users/edit/:userId',
      name: 'users.edit',
      component: EditUser,
      meta: {
        requiresAuth: true,
        requiresPermission: 'manage users'
      },
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (!store.getters.loggedIn) {
      next({ name: 'login'})
    }
    else if (to.matched.some(record => record.meta.requiresPermission)) {

      if ( !store.getters.user) {

        store.dispatch( 'getUser' );
        store.watch( store.getters.userFunction, function(){

          if( !store.getters.user.permissions.includes(to.meta.requiresPermission) ){
            next({ name: 'home'})
          } else {
            next()
          }
        });

      }

      else if (!store.getters.user.permissions.includes(to.meta.requiresPermission)) {
        next({ name: 'home'})
      } else {
        next()
      }
    }
    else {
      next()
    }

  } else if (to.matched.some(record => record.meta.requiresVisitor)) {

    if (store.getters.loggedIn) {
      next({ name: 'home' })
    } else {
      next()
    }

  } else {
    next()
  }
})

export default router


